import { Timestamped } from '../timestamped';
import { z } from 'zod';

export const DsiAdditionalModel = Timestamped.merge(
    z.object({
        modelId: z.string(),
    }),
);
export type DsiAdditionalModel = z.infer<typeof DsiAdditionalModel>;
